<!-- Result.vue -->
<template>
  <div class="result">
    <h1 class="text-uppercase">{{ $t('result.ballGame') }}</h1>
    <p>{{ $t('result.homeScore') }}: {{ homeScore }}</p>
    <p>{{ $t('result.guestScore') }}: {{ guestScore }}</p>
    <h2>{{ $t('result.winner') }}: {{ winner }}</h2>
    <div class="d-flex justify-content-center pointer my-2" @click="downloadPdf">
      <img width="20" src="@/assets/icons/file-pdf.svg" alt="PDF Icon" class="pdf-icon mr-1" />{{ $t('result.downloadPdf') }}
    </div>
    <button class="btn btn-bb5-yellow m-0 p-2 my-2" @click="restartGame">{{ $t('result.newGame') }}</button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import pdfMixin from "@/mixins/pdf";

export default {
  mixins: [pdfMixin],
  props: {
    homeScore: Number,
    guestScore: Number,
  },
  computed: {
    ...mapState(["game", "score"]),
    winner() {
      return this.homeScore > this.guestScore ? this.game.home.team : this.game.guest.team;
    }
  },
  methods: {
    restartGame() {
      // Implement logic to restart the game
      this.$emit('restart-game');
    },
    downloadPdf() {
      this.generatePdf(this.score); // PDF-Generierung aufrufen
    }
  }
};
</script>

<style scoped>
.result {
  text-align: center;
  padding: 20px;
}
</style>
